import { useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'GET_ADDRESS_UNDELIVERABLE';

const useGetAddressUndeliverableQuery = () => {
  const { params: { id } } = useRouteMatch<{ id: string }>();

  const { data, isLoading, refetch } = useQuery(
    [QUERY_KEY, id],
    () => api.get(API_URL.EMPLOYEES_PERSONAL_INFO_BY_EMPLOYEE_ID(id)),
    {
      enabled: Boolean(id),
    },
  );

  const mailingAddress = data?.data?.mailing_address;

  const formattedAddress = useMemo(() => {
    const address = mailingAddress?.address;
    if (!address) return '';
    const parts = [
      address.line1,
      address.line2,
      address.city,
      address.state,
      address.zipcode,
    ].filter(Boolean);
    return parts.join(', ');
  }, [mailingAddress]);

  const formattedData = useMemo(() => ({
    isUndeliverable: mailingAddress?.address?.undeliverable === true,
    undeliverableAt: mailingAddress?.address?.undeliverable_at || null,
    addressId: mailingAddress?.address?.id || null,
    formattedAddress,
    addressPayload: mailingAddress?.address ? {
      id: String(mailingAddress.address.id || ''),
      street: mailingAddress.address.line1 || '',
      street_2: mailingAddress.address.line2 || '',
      city: mailingAddress.address.city || '',
      state: mailingAddress.address.state || '',
      zipCode: mailingAddress.address.zipcode || '',
      address_type: mailingAddress.address.address_type || 'UNKNOWN',
    } : undefined,
  }), [mailingAddress, formattedAddress]);

  return {
    ...formattedData,
    isLoading,
    refetch,
  };
};

export default useGetAddressUndeliverableQuery;
